export const handleKeydownEvents = (handlers, e) => {
    for (const [key, funcs] of Object.entries(handlers)) {
        if (e.key === key) {
            for (const func of funcs) {
                func.call(null, e);
            }
        }
    }
};

export const addKeydownEventListener = (el, handlers) => {
    el.addEventListener("keydown", handleKeydownEvents.bind(null, handlers));
};
